import React from "react";

const Placeholder = ({ depth }) => {
  const marginLeft = depth * 10;
  return <div className="skirt-placeholder" style={{ marginLeft }} />;
};

export default Placeholder;
